import ZipCodeForm from '../components/ZipCodeForm';
import PdfExport from '../components/PdfExport';

function ShulSettings() {
  const styles = {
    pageContainer: {
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      padding: '0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    header: {
      background: 'linear-gradient(to right, #ffffff 0%, #f8fafc 100%)',
      color: '#1e293b',
      padding: 'clamp(24px, 4vw, 32px) clamp(16px, 4vw, 40px)',
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      marginBottom: '0',
      borderBottom: '1px solid #e2e8f0'
    },
    headerTitle: {
      margin: '0',
      fontSize: 'clamp(1.5rem, 4vw, 1.75rem)',
      fontWeight: '600',
      letterSpacing: '-0.3px',
      color: '#0f172a'
    },
    contentWrapper: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: 'clamp(20px, 4vw, 40px)'
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Shul Settings</h1>
      </div>

      <div style={styles.contentWrapper}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
          <PdfExport />
        </div>
        <ZipCodeForm />
      </div>
    </div>
  );
}

export default ShulSettings;
